export function SessionStatus({ children = 'Restoring your session…' }: { children?: React.ReactNode }) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        height: '100vh',
        background: 'var(--bg)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'var(--mono)',
        fontSize: 12,
        letterSpacing: '0.08em',
        color: 'var(--text-3)',
      }}
    >
      {children}
    </div>
  )
}
